import React, { Component } from 'react';
import { createOptionalContext } from '../../../utils/create-optional-context.js';
import { FormContext } from '../../form/context/form-context.js';
const [FieldContext, FieldContextConsumer, FieldContextProvider, useField, useOptionalField,] = createOptionalContext('FieldContext');
class FieldProvider extends Component {
    constructor() {
        super(...arguments);
        this.resetChildValidations = () => {
            if (!this.context) {
                return;
            }
            this.context.resetEntryChildValidations(this.props.entry);
        };
        this.updateChildValidations = (validations) => {
            if (!this.context) {
                return;
            }
            this.context.updateEntryChildValidations(this.props.entry, validations);
        };
    }
    render() {
        const context = {
            resetChildValidations: this.resetChildValidations,
            updateChildValidations: this.updateChildValidations,
        };
        return (React.createElement(FieldContextProvider, { value: context }, this.props.children));
    }
}
FieldProvider.contextType = FormContext;
export { FieldContext, FieldContextConsumer, FieldProvider, useField, useOptionalField, };
//# sourceMappingURL=field-context.js.map